import { INBOUND_CALL_QUEUING_COMPANY_IDS } from '@main/config/feature-flags.config';

export class FeatureFlagStore {
  private static _isPollingEnabled = false;

  static init(companyId: number): void {
    this._isPollingEnabled =
      INBOUND_CALL_QUEUING_COMPANY_IDS.includes(companyId);
  }

  static get isPollingEnabled(): boolean {
    return this._isPollingEnabled;
  }
}
